import { call, put } from 'redux-saga/effects'
import { apiConfig } from '../../../../../config/api-config'
import { makeAccess } from '../../../../../config/factory-controller'
import type { ValidateTokenRequest } from '../../../domain/models/reset-password'
import { AuthorizationTokenService } from '../../../service/authorization-token-service'
import * as action from '../actions/reset-password-actions'

export const validateTokenController = async (payload: ValidateTokenRequest) => {
  const { key, token } = await makeAccess()
  const dataSource = new AuthorizationTokenService(apiConfig(key, token))
  const result = await dataSource.validateToken(payload)
  
  return result
}

export function* validateTokenSaga({ payload }: any): any {
  try {
    const result = yield call(validateTokenController, payload)
    if (result.success) {
      yield put(action.validateTokenSuccess(result))
    } else {
      yield put(action.validateTokenError(result.message))
    }
  } catch (error: any) {
    yield put(action.validateTokenError(error.toString()))
  }
}